import { render, staticRenderFns } from "./sdgAndScale.vue?vue&type=template&id=5b4ef34a&"
import script from "./sdgAndScale.vue?vue&type=script&lang=js&"
export * from "./sdgAndScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports